module.exports = __webpack_public_path__ + "static/img/header.57cf476e.png";